import { repairMojibake } from "../../utils/emailHtml";
import AttachmentList from "./AttachmentList";
import EmailHtmlBody from "./EmailHtmlBody";
import styles from "./MessageContent.module.css";

const HTML_TAG_PATTERN = /<\/?[a-z][^>]*>/i;

const getMessageAttachments = (message) =>
  Array.isArray(message?.attachments) ? message.attachments : [];

const looksLikeHtml = (text) => HTML_TAG_PATTERN.test(text || "");

/**
 * Cuerpo y adjuntos de un mensaje del hilo.
 *
 * Usa el HTML original del correo cuando lo hay (con sus imágenes inline y
 * sus estilos). Si no, el cuerpo guardado: como HTML si lo es (las respuestas
 * enviadas desde el CRM) o como texto plano respetando sus saltos de línea.
 * Lo comparten el hilo y el modal de lectura para que el mensaje se vea igual
 * en los dos.
 */
const MessageContent = ({ message, bodyClassName = "", maxImageHeight }) => {
  const attachments = getMessageAttachments(message);
  const storedBody = repairMojibake(message?.body || message?.raw_body || "");
  const emptyBody = (
    <div className={`${styles.plainText} ${bodyClassName}`}>Sin contenido</div>
  );

  let storedBodyContent = emptyBody;
  if (looksLikeHtml(storedBody)) {
    storedBodyContent = (
      <EmailHtmlBody
        html={storedBody}
        className={bodyClassName}
        maxImageHeight={maxImageHeight}
        fallback={emptyBody}
      />
    );
  } else if (storedBody.trim()) {
    storedBodyContent = (
      <div className={`${styles.plainText} ${bodyClassName}`}>{storedBody.trim()}</div>
    );
  }

  return (
    <>
      {message?.html_body?.trim() ? (
        <EmailHtmlBody
          html={message.html_body}
          attachments={attachments}
          className={bodyClassName}
          maxImageHeight={maxImageHeight}
          fallback={storedBodyContent}
        />
      ) : (
        storedBodyContent
      )}
      <AttachmentList attachments={attachments} />
    </>
  );
};

export default MessageContent;
